/**
 * Checks the URL to see if it is a MFN link.
 */
export const isMFNLink = (url: string | null) => url?.match(/^https?:\/\/(www\.)?mfn\.se/)

/**
 * Returns the intersection of two arrays.
 */
export const intersection = <T = 'string'>(a: T[], b: T[]) => a?.filter((value) => b?.includes(value))

/**
 * Checks if the URL is an external link, ie begins with http.
 * Otherwise it is assumed to be an S3 link (a.k.a internal link).
 */
export const isExternalLink = (url: string) => url?.startsWith('http')
